import type {PublicMethodUtils} from '@wix/document-services-types'
import type {AccessibilityPublicAPI} from '@wix/document-services-public-types'
import {
    visualFocusData,
    autoDomReorderData,
    componentA11yAPI,
    skipToContentData,
    languageDirection
} from '@wix/document-services-implementation'
import type {PublicModuleDeclaration} from '../../documentServicesInitialisation'

export default function (publicMethodUtils: PublicMethodUtils): PublicModuleDeclaration<AccessibilityPublicAPI> {
    return {
        methods: {
            components: {
                getA11ySchema: publicMethodUtils.defineGetter(componentA11yAPI.getA11ySchema)
            },
            accessibility: {
                isRTL: publicMethodUtils.defineAction(languageDirection.isRTL),
                getSiteDirection: publicMethodUtils.defineGetter(languageDirection.getSiteDirection),
                setSiteDirection: publicMethodUtils.defineDataManipulationAction(languageDirection.setSiteDirection),
                executeDomOrder: publicMethodUtils.defineAction(languageDirection.executeDomOrder),
                visualFocus: {
                    get: publicMethodUtils.defineGetter(visualFocusData.get),
                    set: publicMethodUtils.defineDataManipulationAction(visualFocusData.set)
                },
                autoDomReorder: {
                    get: publicMethodUtils.defineGetter(autoDomReorderData.get),
                    set: publicMethodUtils.defineDataManipulationAction(autoDomReorderData.set)
                },
                skipToContent: {
                    get: publicMethodUtils.defineGetter(skipToContentData.get),
                    set: publicMethodUtils.defineDataManipulationAction(skipToContentData.set)
                }
            }
        }
    }
}
